import { z } from 'zod';

export const naturalPersonSchema = z.object({
  idLegalClientType: z.number().int(),
  idAcademicTitle: z.number().int(),
  idCountry: z.number({ required_error: 'Land ist verpflichtend' }).int(),
  idGender: z.number({ required_error: 'Geschlecht ist verpflichtend' }).int(),

  Birthdate: z.string().length(10).nullable(),
  Birthplace: z.string().nullable(),
  DateOfDeath: z.string().nullable(),
  PlaceOfDeath: z.string().nullable(),
  FirstName: z
    .string({ required_error: 'Vorname ist verpflichtend' })
    .min(1, 'Vorname ist verpflichtend'),
  LastName: z
    .string({ required_error: 'Nachname ist verpflichtend' })
    .min(1, 'Nachname ist verpflichtend'),
});

export type INaturalPerson = z.infer<typeof naturalPersonSchema>;

export const getEmptyNaturalPerson = (): INaturalPerson => {
  return {
    idLegalClientType: 1,
    idAcademicTitle: 1,
    idCountry: 1,
    idGender: 0,
    Birthdate: null,
    Birthplace: null,
    DateOfDeath: null,
    FirstName: '',
    LastName: '',
    PlaceOfDeath: null,
  };
};
